// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"1705":"PrototypeViewer","2348":"livekit-egress-template"}[chunkId] || chunkId) + "." + {"1358":"50eb1ef5e3fd994ea988","1705":"50eb1ef5e3fd994ea988","1896":"db276ef0627113c0169e","2348":"b8db09b550a9f97a1399","4865":"9731d6bf278c4c252090","6116":"b511dfaf4b5d6ee57923"}[chunkId] + ".chunk.css";
};